import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';
import { useObjectDatesMapper } from './Helper';

export interface CreateTokenRequest {
  name: string;
  expiresAt?: Date;
}

export interface ApiToken {
  id: number
  name: string;
  apiToken: string;
  expiresAt: Date | null;
  lastUsedAt: Date | null;
  isTokenHidden: boolean;
  isExpired: boolean;
}

export const API_TOKENS_UPDATED = 'API_TOKENS_UPDATED';

export function useApiTokensService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();
  const datesMapper = useObjectDatesMapper<ApiToken>([], ['expiresAt', 'lastUsedAt']);


  const createToken = async (request: CreateTokenRequest): Promise<ApiToken> => {
    const response = await nekstApi.post('/integrations/apitokens', request) as ApiToken;
    eventsPublisher.publish(API_TOKENS_UPDATED, {});
    return datesMapper.mapSingle(response);
  };

  const getApiTokens = async (): Promise<ApiToken[]> => {
    const response = await nekstApi.get('/integrations/apitokens') as ApiToken[];
    return datesMapper.mapList(response);
  };

  const getToken = async (tokenId: number): Promise<ApiToken> => {
    const response = await nekstApi.get(`/integrations/apitokens/${tokenId}`) as ApiToken;
    return datesMapper.mapSingle(response);
  };

  const deleteToken = async (tokenId: number): Promise<void> => {
    await nekstApi.delete(`/integrations/apitokens/${tokenId}`);
    eventsPublisher.publish(API_TOKENS_UPDATED, {});
  };

  return {
    createToken,
    getApiTokens,
    getToken,
    deleteToken,
  };
}
